/**
 * Solicitante (Requester) section for CreateSolicitudDialog
 */
import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';

const SolicitanteSection = ({ 
  formData, 
  titularEsSolicitante, 
  onTitularEsSolicitanteChange, 
  onFieldChange 
}) => {
  return (
    <>
      {/* Checkbox Titular = Solicitante */}
      <div className="flex items-center space-x-3 py-1 sm:py-2">
        <Checkbox
          id="titularEsSolicitante"
          checked={titularEsSolicitante}
          onCheckedChange={onTitularEsSolicitanteChange}
          className="border-[#9d8272] data-[state=checked]:bg-[#9d8272]"
          data-testid="titular-es-solicitante-checkbox"
        />
        <Label htmlFor="titularEsSolicitante" className="text-xs sm:text-sm font-medium cursor-pointer">
          El Titular es el mismo que el Solicitante
        </Label>
      </div>

      {/* Sección Solicitante */}
      {!titularEsSolicitante && (
        <div className="border border-[#E8E8E7] rounded-lg p-3 sm:p-4 bg-[#FAFAFA]">
          <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#2D2D2D] mb-2 sm:mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            Datos del Solicitante
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
            <div>
              <Label className="text-xs sm:text-sm">Nombre *</Label>
              <Input
                value={formData.solicitante_nombre}
                onChange={(e) => onFieldChange('solicitante_nombre', e.target.value)}
                className="border-[#c5b8a2] text-sm"
                required={!titularEsSolicitante}
                data-testid="solicitante-nombre"
              />
            </div>
            <div>
              <Label className="text-xs sm:text-sm">Email *</Label>
              <Input
                type="email"
                value={formData.solicitante_email}
                onChange={(e) => onFieldChange('solicitante_email', e.target.value)}
                className="border-[#c5b8a2] text-sm"
                required={!titularEsSolicitante}
                data-testid="solicitante-email"
              />
            </div>
            <div>
              <Label className="text-xs sm:text-sm">Teléfono *</Label>
              <Input
                value={formData.solicitante_telefono}
                onChange={(e) => onFieldChange('solicitante_telefono', e.target.value)}
                className="border-[#c5b8a2] text-sm"
                required={!titularEsSolicitante}
                data-testid="solicitante-telefono"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SolicitanteSection;
